import { axiosInstance } from "../client";
import { DocumentTemplate } from "@rumble-it/common-lib/types/models/DocumentTemplate.interface";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";

export const fetchDocumentTemplates = async (): Promise<
  CollectionResponse<DocumentTemplate>
> =>
  axiosInstance
    .get(`/admin/documents/templates`)
    .then((response) => response.data);

export const createDocumentTemplate = async (
  data: DocumentTemplate,
): Promise<DocumentTemplate> =>
  axiosInstance
    .post(`/admin/documents/templates`, data)
    .then((response) => response.data);

export const deleteDocumentTemplateById = async (id: string): Promise<null> =>
  axiosInstance
    .delete(`/admin/documents/templates/${id}`)
    .then((response) => response.data);

export const fetchDocumentTemplateById = async (
  id: string,
): Promise<DocumentTemplate> =>
  axiosInstance
    .get(`/admin/documents/templates/${id}`)
    .then((response) => response.data);
